import { NgModule } from '@angular/core';

import { ChartComponent } from './chart.component';
import { ChartsConfigService } from './service/charts-config.service';

@NgModule({
  imports: [ChartComponent],
  exports: [ChartComponent],
  providers: [
    ChartsConfigService
  ]
})
export class ChartsModule {
}
